<template>
  <v-form ref="ADRESSE" @submit.prevent="sectionSave" lazy-validation class="section">
    <div>
      <section-header v-if="!hideTitle"
                      :ressource="ressource"
                      :isExtended="extended"
                      :dialog="dialog"
                      :picto="picto()"
                      :fiche=fiche
                      :isAbstract=isAbstract
                      @extended=setExtended
                      @closeDialog=closeDialog
                      ref="ADRESSE">
      </section-header>
      <div v-if="extended" id="field-container" :class="dialog ? 'p-0 p-md-3' : 'py-2'">
        <adresse-ban-search v-if="!readOnly('ADRESSE1')"
                            :disabled="!editAdresse.canUpdate"
                            @select="onBanSelect">
        </adresse-ban-search>
        <adresse-adresse1 v-if="isDisplayed('ADRESSE1')"
                          ref="ADRESSE1"
                          :theme="theme"
                          :showMissing="showMissing"
                          v-model:value=adresse1
                          :max="36"
                          @status=statusAdresse1
                          :over-ride-placeholder=placeholderAdresse1
                          :required="isRequired('ADRESSE1')"
                          :contextId=adresse.id
                          :readOnly="readOnly('ADRESSE1')"
                          :objType=objType
                          :fiche=fiche
                          :sectionName="sectionName">
        </adresse-adresse1>
        <adresse-adresse2 v-if="isDisplayed('ADRESSE2')"
                          ref="ADRESSE2"
                          :theme="theme"
                          :showMissing="showMissing"
                          v-model:value=adresse2
                          :max="36"
                          @status=statusAdresse2
                          :over-ride-placeholder=placeholderAdresse2
                          :required="isRequired('ADRESSE2')"
                          :contextId=adresse.id
                          :readOnly="readOnly('ADRESSE2')"
                          :objType=objType
                          :fiche=fiche
                          :sectionName="sectionName">
        </adresse-adresse2>
        <adresse-code-postal v-if="isDisplayed('CODE_POSTAL')"
                             ref="CODE_POSTAL"
                             :theme="theme"
                             :showMissing="showMissing"
                             v-model:value=codePostal
                             :min="5"
                             :max="5"
                             @status=statusCodePostal
                             :over-ride-placeholder=placeholderCodePostal
                             :required="isRequired('CODE_POSTAL')"
                             :contextId=adresse.id
                             :readOnly="readOnly('CODE_POSTAL')"
                             :objType=objType
                             :fiche=fiche
                             :sectionName="sectionName">
        </adresse-code-postal>
        <adresse-ville v-if="isDisplayed('VILLE')"
                       ref="VILLE"
                       :theme="theme"
                       :showMissing="showMissing"
                       v-model:value=ville
                       :max="32"
                       @status=statusVille
                       :over-ride-placeholder=placeholderVille
                       :required="isRequired('VILLE')"
                       :contextId=adresse.id
                       :readOnly="readOnly('VILLE')"
                       :objType=objType
                       :fiche=fiche
                       :sectionName="sectionName">
        </adresse-ville>
        <pays-select v-if="isDisplayed('PAYS_ID')"
                     ref="PAYS_ID"
                     :theme="theme"
                     :showMissing="showMissing"
                     v-model:value=paysId
                     :moduleId=moduleId
                     libelle="'Pays'"
                     newLabel=''
                     selectText=""
                     @status=statusPaysId
                     :requiredAttributs="requiredAttributs"
                     :autoSelect=true
                     :ressource=ressourcePaysSelect
                     :filters=paysIdFilter
                     :toggleReset=resetPaysId
                     :required="isRequired('PAYS_ID')"
                     :contextId=adresse.id
                     :readOnly="readOnly('PAYS_ID')"
                     :objType=objType
                     :fiche=fiche
                     :sectionName="sectionName">
        </pays-select>
      </div>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <loader-button v-if="saveButton"
                     class="ms-2"
                     type="submit"
                     :loading="saveLoading"
                     :label="saveLabel"
                     :disabled="!updatedAndValid">
      </loader-button>
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button class="ms-2"
                       :outlined="button.outlined"
                       @callback="button.callback()"
                       :type="button.type"
                       :label="button.label"
                       :loading="button.loading"
                       :disabled="button.disabled">
        </loader-button>
      </div>
    </div>
    <div class="d-flex flex-row-reverse" v-if="saveFailed && saveButton && extended">
      <p class="text-12 text-bold error-text">{{errorTxt}}</p>
    </div>
  </v-form>
</template>

<script lang="ts">
  import SectionAdresse from '@/generated/sections/SectionAdresse.vue';
  import { defineComponent, type PropType } from "vue";
  import Owner from '@/generated/classes/Owner';
  import AdresseBanSearch from '@/extend/controls/adresse/AdresseBanSearch.vue';

  interface BanAddress {
    adresse1: string;
    codePostal: string;
    ville: string;
  }

  export default defineComponent({
    components: { AdresseBanSearch },
    extends: SectionAdresse,
    props: {
      owner: {
        type: Object as PropType<Owner>
      },
    },
    methods: {
      // Préremplit les champs depuis une adresse choisie dans la recherche BAN.
      // On passe par setUpdated(value) de chaque contrôle : il émet `update:value`
      // (met à jour le v-model => editAdresse) ET `status` (active le bouton Enregistrer).
      onBanSelect(addr: BanAddress): void {
        const r = this.$refs as Record<string, { setUpdated(value: string): void } | undefined>;
        if (this.isDisplayed('ADRESSE1') && r.ADRESSE1) {
          r.ADRESSE1.setUpdated(addr.adresse1);
        }
        if (this.isDisplayed('CODE_POSTAL') && r.CODE_POSTAL) {
          r.CODE_POSTAL.setUpdated(addr.codePostal);
        }
        if (this.isDisplayed('VILLE') && r.VILLE) {
          r.VILLE.setUpdated(addr.ville);
        }
      },
    },
  })

</script>
